import { Pipe, PipeTransform } from '@angular/core';
import {FlightClass, FLIGHT_CLASS_LABEL} from '../../models/DealsModels';


@Pipe({
    name: 'flightClassLabel',
})
export class FlightClassLabelPipe implements PipeTransform {
    transform(flightClass: FlightClass): string {
        return FLIGHT_CLASS_LABEL[flightClass];
    }
}
